import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Preloader from '../preloader/Preloader'

//services
import { getMachineSingle, createMachines, updateMachines } from 'src/services'

//components
import { BreadCrumb, Card } from 'src/components'

const CreateOrUpdate = () => {
  const history = useHistory()
  const { id } = useParams()
  const isUpdating = id !== undefined
  const [loading, setLoading] = useState(isUpdating)
  const [machineList, setMachineList] = useState({
    name: '',
    machine_code: '',
    error_list: [],
  })

  useEffect(() => {
    if (isUpdating) {
      getMachineSingle(id)
        .then((res) => {
          if (res.data.status === 200) {
            setMachineList(res.data.machine)
          } else {
            history.push('/machines')
          }
          setLoading(false)
        })
        .catch(() => {
          history.push('/machines')
          setLoading(false)
        })
    }
  }, [id, history, isUpdating])

  const handleInput = (e) => {
    e.persist()
    setMachineList({ ...machineList, [e.target.name]: e.target.value })
  }

  const submitForm = (e) => {
    e.preventDefault()
    const data = machineList

    const submitAction = isUpdating ? () => updateMachines(id, data) : () => createMachines(data)

    submitAction()
      .then((res) => {
        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success')
          history.push('/machines')
        } else if (res.data.status === 400 || res.data.status === 422) {
          setMachineList({ ...machineList, error_list: res.data.errors || {} })
        }
      })
      .catch((error) => {
        swal('Error', 'An error occurred', 'error')
      })
  }

  if (loading) {
    return <Preloader />
  }

  const title = 'Machines'
  const isanupdate = isUpdating ? 'Update' : 'Add'

  const breadcrumb = [
    {
      title: title,
      name: 'Add Machine',
      subtitle: isanupdate,
      subtitleroute: '/machines',
    },
  ]

  const cardValues = [
    {
      title: 'Machines',
      addorupdate: isanupdate,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <div className="content">
        <div className="card card-primary">
          <Card data={cardValues}>
            <form onSubmit={submitForm}>
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="pb-2">
                      Machine Code <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="machine_code"
                      onChange={handleInput}
                      value={machineList.machine_code}
                      placeholder="Machine Code"
                    />
                    <span className="text-danger">{machineList?.error_list?.machine_code}</span>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="pb-2">
                      Machine Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      onChange={handleInput}
                      value={machineList.name}
                      placeholder="Machine Name"
                    />
                    <span className="text-danger">{machineList?.error_list?.name}</span>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary mt-3">
                {isUpdating ? 'Update' : 'Save'}
              </button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default CreateOrUpdate
